type SetCookieOptions = {
  maxAge?: number;
  path?: string;
  domain?: string;
};

/**
 * Définit un cookie
 * @param name - Nom du cookie
 * @param value - Valeur du cookie
 * @param options - Options du cookie (maxAge, path, domain)
 */
export const setCookie = (
  name: string,
  value: string,
  options: SetCookieOptions = {}
): void => {
  if (typeof window === 'undefined') return;

  const domain =
    options.domain ??
    `.${window.location.hostname.split('.').slice(-2).join('.')}`;
  const path = options.path ?? '/';
  const maxAgeStr = options.maxAge ? `; max-age=${options.maxAge}` : '';

  document.cookie = `${name}=${value}${maxAgeStr}; path=${path}; domain=${domain}`;
};

/**
 * Récupère la valeur d'un cookie
 * @param name - Nom du cookie
 * @returns La valeur du cookie ou undefined
 */
export const getCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') return undefined;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop()?.split(';').shift();
  }

  return undefined;
};

/**
 * Supprime un cookie
 * @param name - Nom du cookie à supprimer
 */
export const removeCookie = (name: string): void => {
  if (typeof window === 'undefined') return;

  const domain = `.${window.location.hostname.split('.').slice(-2).join('.')}`;
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`;
};
